var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper app-root",attrs:{"id":"shop_app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('snackbar-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }